export default "__VITE_ASSET__PrpD2oQN__"